<template>
  <div class="c-app-install">
    <v-btn
      v-show="showInstallButton"
      v-tooltip="$t('tooltip.appBar.install')"
      class="ml-2"
      :data-title="$t('tour.appBar.installButton.title')"
      :data-intro="$t('tour.appBar.installButton.intro')"
      fab
      small
      @click="onInstall"
    >
      <v-icon color="accent"> mdi-tray-arrow-down </v-icon>
    </v-btn>
    <AppInstallPopup
      v-if="showInstallPopup"
      v-model="showInstallPopup"
      :device="iosDeviceType"
      @cancel="showInstallPopup = $event"
    />
  </div>
</template>

<script>
import AppInstallPopup from '@/components/app/AppInstallPopup'
import mobileMixin from '@/mixins/mobileMixin.js'
import pwaMixin from '@/mixins/pwaMixin.js'

class InstallError extends Error {
  constructor(message, options = {}) {
    super(message, options)
    this.name = 'InstallError'
  }
}

export default {
  name: 'AppInstall',

  components: {
    AppInstallPopup
  },

  mixins: [mobileMixin, pwaMixin],

  data() {
    return {
      // installation
      showInstallButton: false,
      showInstallPopup: false,
      installEvent: null,
      isInstalled: false
    }
  },

  computed: {
    iosDeviceType() {
      if (this.mobileMixin_isiPad) return 'iPad'
      if (this.mobileMixin_isiPhone) return 'iPhone'
      return ''
    },

    isManualInstall() {
      // !(this.mobileMixin__isSafari && this.mobileMixin_isMac)
      const iosVersion = this.mobileMixin_iOSVersion
      console.debug('[AppInstall]: iOS Version=', iosVersion)
      console.debug('[AppInstall]: userAgent=', window.navigator.userAgent)
      if (this.mobileMixin_isiOS) {
        const isVersionSupported =
          (this.mobileMixin_isSafari && iosVersion >= 15.0) ||
          (this.mobileMixin_isChromeOrEdge && iosVersion >= 16.4)
        return isVersionSupported
      } else {
        return false
      }
    },

    isPWA() {
      return this.pwaMixin_isPWA
    }
  },

  watch: {
    isInstalled: {
      immediate: true,
      handler: function (newInstalled, _oldInstalled) {
        if (newInstalled) this.showInstallButton = false
      }
    }
  },

  mounted: function () {
    // from browser (only supported by Chrome and Edge)
    document.addEventListener('CustomBeforeInstallPrompt', this.onBeforeInstall)
    document.addEventListener('CustomAppInstalled', this.onInstalled)

    // determine whether running as a PWA
    window
      .matchMedia('(display-mode: minimal-ui)')
      .addEventListener('change', this.onDisplayModeChange)
    window
      .matchMedia('(display-mode: standalone)')
      .addEventListener('change', this.onDisplayModeChange)

    this.isInstalled = this.isPWA
    console.debug('[AppInstall]: isPWA=', this.isInstalled)

    if (this.isManualInstall && !this.isInstalled) {
      this.showInstallButton = true
    }
  },

  beforeDestroy: function () {
    document.removeEventListener('CustomBeforeInstallPrompt', this.onBeforeInstall)
    document.removeEventListener('CustomAppInstalled', this.onInstalled)

    window
      .matchMedia('(display-mode: minimal-ui)')
      .removeEventListener('change', this.onDisplayModeChange)
    window
      .matchMedia('(display-mode: standalone)')
      .removeEventListener('change', this.onDisplayModeChange)
  },

  methods: {
    /* installation detection methods */

    onDisplayModeChange(e) {
      if (e.matches) {
        this.isInstalled = true
      }
    },

    /* installation methods */

    onBeforeInstall(e) {
      console.debug('[AppInstall]: onBeforeInstallPrompt', e)
      e.preventDefault()
      this.installEvent = e.detail
      this.showInstallButton = true
    },

    async onInstall(_e) {
      if (this.isManualInstall) {
        this.showInstallPopup = true
      } else {
        try {
          // invoke the deferred install event
          this.installEvent.prompt() // can only be called once

          // retrieve prompt outcome
          const { outcome } = await this.installEvent.userChoice

          if (outcome === 'accepted') {
            // beforeInstall event will NOT fire again
            this.installEvent = null
            this.showInstallButton = false
          } else {
            // beforeInstall event will fire again
            this.installEvent = null
            this.showInstallButton = false
          }
        } catch (error) {
          this.$error(new InstallError(error.message))
        }
      }
    },

    async onInstalled(_e) {
      // installButton.style.display = 'none'
      this.isInstalled = true
      console.debug('[AppInstall]: App installed!')
    }
  }
}
</script>

<style lang="css" scoped></style>
